import { createOidcAuth, SignInType } from 'vue-oidc-client';
import { WebStorageStateStore } from 'oidc-client'
import Vue from 'vue';

const fullUrl = window.location;
const appRootUrl = `${fullUrl.protocol}//${fullUrl.host}${process.env.BASE_URL}`;

let mainOidc = createOidcAuth(
  'main',
  SignInType.Window,
  appRootUrl,
  {
    // authority: "http://hydra.roosh.test/",
    // client_id: "ec824274-92d3-11eb-9023-de2e4412e00b",
    authority: process.env.VUE_APP_AUTHORITY,
    client_id: process.env.VUE_APP_CLIENT_ID,
    response_type: 'code',
    scope: 'offline email openid',
    redirect_uri: `${appRootUrl}callback`,
    extraQueryParams: {
      one_time: true,
    },
    userStore: new WebStorageStateStore({ store: window.localStorage })
  }
);

Vue.prototype.$oidc = mainOidc;

export default mainOidc;
